import {useEffect} from 'react';
import {useTenant} from '../App';

export default function usePageTitle(title, description) {
  const tenant = useTenant();
  useEffect(() => {
    const base = tenant?.name || 'Career Board Central';
    document.title = title ? `${title} — ${base}` : base;
    const meta = document.querySelector('meta[name="description"]');
    if (description) {
      if (meta) { meta.setAttribute('content', description); }
      else {
        const tag = document.createElement('meta');
        tag.name = 'description'; tag.content = description;
        document.head.appendChild(tag);
      }
    }
    return () => { document.title = base; };
  }, [title, description, tenant]);
}
